import { makeAutoObservable } from 'mobx';
import { noop } from 'lodash';
import { getCustomerEligibility, requestEnrollmentService } from '../api/SlmService';

class AuthStore {
  authorized = false;

  notProUser = false;

  isNotLoggedIn = false;

  authInProgress = true;

  proxtraSuspended = false;

  errorCode = null;

  enrollmentInProgress = false;

  customer = {};

  setAuthorized = (value) => {
    this.authorized = value;
  };

  setAuthInProgress = (value) => {
    this.authInProgress = value;
  };

  setCustomer = (customer) => {
    this.customer = customer;
  }

  updateEnrollmentInProgress = (updatedValue) => {
    this.enrollmentInProgress = updatedValue;
  };

  requestEnrollment = async () => {

    this.updateEnrollmentInProgress(true);
    try {
      let response = await requestEnrollmentService();

      this.updateEnrollmentInProgress(false);
      this.setAuthorized(true);
      return response;
    } catch (err) {
      this.updateEnrollmentInProgress(false);
      return err;
    }
  };

  setErrorCode = (errorCode) => {
    this.errorCode = errorCode;
  };

  constructor() {
    makeAutoObservable(this);
  }

  /* for some reason async function works wrong inside constructor, cause unexpected authInProgress state changes on init state */
  initAuth = async (cb = noop) => {
    this.setAuthInProgress(true);

    try {
      const response = await getCustomerEligibility();
      this.setCustomer(response?.data?.cicCustomer);
      this.setAuthorized(true);
    } catch (error) {
      let errorCode = error.response?.data?.code || error?.response?.status;

      if (error?.message === 'Oops something went wrong.') {
        errorCode = 503;
      }

      this.setErrorCode(errorCode);
      this.setAuthorized(false);
      if (errorCode === 9) {
        this.isNotLoggedIn = true;
      }
      if (errorCode === 25) {
        this.notProUser = true;
      }
      if (errorCode === 26) {
        this.proxtraSuspended = true;
      }
      cb(error.response?.data?.message, errorCode);
    } finally {
      this.setAuthInProgress(false);
    }
  };
}

export default new AuthStore();
